<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`${this.lessonContentUnlockCode ? '강의 접속코드 수정' : '강의 접속코드 생성'}`"
    :confirm="save"
    :close="close"
    :confirmButtonTitle="`${this.lessonContentUnlockCode ? '수정' : '저장'}`"
    name="lessonContentUnlockCodeModal"
  >
    <b-container>
      <b-row>
        <b-col cols="12">접속 코드 유효 기간</b-col>
        <b-col cols="4">
          <label for="start_date">시작 일자</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="startDate"
          ></b-form-input>
        </b-col>
        <b-col cols="4">
          <label for="end_date">종료 일자</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="endDate"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-input-group prepend="강의 선택">
            <b-form-select
              id="count-select"
              v-model="selectedLessonContentId"
              :disabled="!!lessonContentUnlockCode"
              :options="selectedOptions">
            </b-form-select>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group prepend="접속 코드">
            <b-form-input
              type="text"
              id="count-select"
              v-model="code"
              placeholder="접속 코드를 입력하세요."
            />
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="8">
          <b-col>
            <b-input-group prepend="수강 기간 선택 ">
              <b-form-select v-model="periodType" :options="periodTypeOptions"/>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <b-row v-if="periodType === 'ABS'" class="mt-2">
        <b-col cols="4">
          <label for="end_date">수강 기간 종료 일자</label>
          <b-form-input id="endDt" type="date" v-model="accessEndedAt"/>
        </b-col>
        <div class="text-sm text-rose-600">접속 코드를 학생이 등록한 날짜를 시작으로 지정한 날짜까지 수강 가능합니다.</div>
      </b-row>
      <b-row v-if="periodType === 'DAYS'" class="mt-2">
        <b-col cols="4">
          <b-input-group prepend="수강 기간 (일)">
            <b-form-input type="number" min="1" v-model.number="accessDays" placeholder="0"/>
          </b-input-group>
        </b-col>
        <div class="text-sm text-rose-600">접속 코드를 학생이 등록한 날짜를 시작으로 n일동안 수강 가능합니다.</div>
      </b-row>
      <b-row class="text-right mt-2">
        <b-form>
          <b-form-textarea v-model="memo" placeholder="메모를 입력하세요."/>
        </b-form>
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  name: "LessonContentUnlockCodeModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'lessonContentUnlockCode', 'lessonContents'],
  data() {
    return {
      id: 0,
      memo: "",
      startDate: '',
      endDate: '',
      code: "",
      selectedLessonContentId : 0,
      periodType: 'ABS',
      accessDays: null,
      accessEndedAt: null,
      selectedOptions: [],
      periodTypeOptions: [
        { value: 'ABS',  text: '수강기간 절대 날짜 지정' },
        { value: 'DAYS', text: '수강기간 N일 지정' },
        { value: 'NONE', text: '수강기간 제한 없음' },
      ],
    }
  },
  mounted() {
    this.selectedOptions = this.lessonContents.map((lessonContent) => ({
      value: lessonContent.id,
      text: `${lessonContent.lessonTitle} (${lessonContent.title})`
    }))

    if (this.lessonContentUnlockCode) {
      this.id = this.lessonContentUnlockCode.id
      this.startDate = this.formatDate(this.lessonContentUnlockCode.startedAt)
      this.endDate = this.formatDate(this.lessonContentUnlockCode.endedAt)
      this.memo = this.lessonContentUnlockCode.memo
      this.code = this.lessonContentUnlockCode.code
      this.selectedLessonContentId  = this.lessonContentUnlockCode.lessonContentId

      if (this.lessonContentUnlockCode.accessEndedAt) {
        this.periodType = 'ABS'
        this.accessEndedAt = this.formatDate(this.lessonContentUnlockCode.accessEndedAt)
      } else if (this.lessonContentUnlockCode.accessDays) {
        this.periodType = 'DAYS'
        this.accessDays = this.lessonContentUnlockCode.accessDays
      } else {
        this.periodType = 'NONE'
      }
    } else {
      this.selectedLessonContentId = this.selectedOptions?.[0]?.value || 0
    }
  },
  methods: {
    formatDate(datetimeString) {
      // Create a new Date object from the datetime string
      const date = new Date(datetimeString);

      // Extract year, month, and day with leading zero for month and day
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      // Return formatted date in YYYY-MM-DD format
      return `${year}-${month}-${day}`;
    },
    validate() {
      if (this.periodType === 'ABS' && !(this.accessEndedAt)) {
        this.$toast.show('수강 기간 종료 일자를 선택하세요.', { position: 'top-right', duration: 2000 })
        return false
      }
      if (this.periodType === 'DAYS' && (!this.accessDays || this.accessDays < 1)) {
        this.$toast.show('수강 기간(N일)을 입력하세요.', { position: 'top-right', duration: 2000 })
        return false
      }
      if (!this.code) {
        this.$toast.show('접속 코드를 입력하세요.', { position: 'top-right', duration: 2000 })
        return false
      }

      if (!(this.startDate && this.endDate)) {
        this.$toast.show('시작 일자, 종료 일자를 선택하세요',
          {
            position: "top-right",
            duration: 2000
          });
        return false
      }
      
      return true
    },
    buildPayload() {
      let base = {
        code: this.code,
        type: this.type,
        startedAt: `${this.startDate}`,
        endedAt : `${this.endDate}`,
        memo: this.memo
      }
      
      if (this.lessonContentUnlockCode) {
        base = {
          ...base,
          id: this.lessonContentUnlockCode.id
        }
      } else {
        base = {
          ...base,
          lessonContentId: this.selectedLessonContentId
        }
      }
      
      if (this.periodType === 'ABS') {
        return { ...base, accessEndedAt: `${this.accessEndedAt}`, accessDays: null }
      }
      if (this.periodType === 'DAYS') {
        return { ...base, accessEndedAt: null, accessDays: this.accessDays }
      }
      return { ...base, accessEndedAt: null, accessDays: null}
    },
    save() {
      if (!this.validate()) return

      const payload = this.buildPayload()
      const apiCall = this.lessonContentUnlockCode
        ? api.lessonContentUnlockCode.updateLessonContentUnlockCode
        : api.lessonContentUnlockCode.createLessonContentUnlockCode

      apiCall(payload, () => {
        this.reload();
        this.close();
      }, (error) => {
        this.$toast.show(error.response.data.message, {
          type: 'error', position: 'top-right', duration: 2000, max: 10,
        })
      })
    },
  }
}
</script>

<style scoped>

</style>